import React from 'react'
import glamorous from 'glamorous'

const ContinueButton = glamorous.div({
  width: '100%',
  height: 46,
  backgroundImage: `url(${require('./continue-with-facebook.png')})`,
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center'
})

const LoginButton = () => {
  return (
    <ContinueButton onClick={requestFBLogin} />
  )
}

const requestFBLogin = () => window.FB.login((response) => {
}, {scope: 'user_link'})

export default LoginButton



// WEBPACK FOOTER //
// ./src/components/login/LoginButton.js